import { lazy, Suspense } from "react";
import type { LaboDraw } from "../labo/laboStats";
import { GenerateurPublic, Reserve, sessionSupposee } from "./GenerateurPublic";

// Vérification de la session (React Query, AuthProvider) chargée seulement si le navigateur porte
// le drapeau has_session : un anonyme ne télécharge que le générateur public.
const GenerateurConnecte = lazy(() => import("./GenerateurConnecte"));

/**
 * Îlot de /generateur-grille-keno/ (D7). La page est la même pour tous, en cache public :
 * le choix se fait ici, dans le navigateur.
 */
export function GenerateurIsland({ tiragesDesc, exemple = false }: { tiragesDesc: LaboDraw[]; exemple?: boolean }) {
  if (!sessionSupposee()) return <GenerateurPublic tiragesDesc={tiragesDesc} exemple={exemple} />;
  return (
    <Suspense fallback={<Reserve />}>
      <GenerateurConnecte tiragesDesc={tiragesDesc} exemple={exemple} />
    </Suspense>
  );
}
